module.exports = __webpack_public_path__ + "img/10.eb10f3e3.svg";